const apiConfig = {
  apiformbaseurl: 'https://vmc-feedback-api.codingblocks.com/api'
};

export default process.env.NODE_ENV === 'production' ? {
  s3HomeworkBucket: 'private-assets-studentapp',
  awsRegion: 'ap-south-1'
} : {
  s3HomeworkBucket: 'private-app-videos',
  awsRegion: 'us-east-1'
};

export { apiConfig };